// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-21733be5]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.btnGroup[data-v-21733be5]{display:flex;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
